export default __webpack_public_path__ + "static/media/parts.e80ba4cc.jpg";